<app-auth-shell panelClass="max-w-[620px]">
  <div class="p-6 sm:p-8 lg:p-10">
    <div class="mb-8">
      <div
        class="mb-3 inline-flex rounded-full border border-periwinkle-border bg-periwinkle-soft px-3 py-1 inter-500 text-[12px] text-periwinkle"
      >
        Account recovery
      </div>
      <h1
        class="font-spaceGrotesk text-[30px] font-semibold leading-tight text-inverted-neutral sm:text-[38px]"
      >
        Forgot password
      </h1>
      <p class="mt-3 inter-300 text-[15px] leading-6 text-support-text">
        Enter the email you used to sign up. If it is linked to an account,
        we will send you a reset link.
      </p>
    </div>

    <input
      [formControl]="forgotPasswordForm.controls.email"
      type="text"
      placeholder="Email"
      class="form-control mb-6"
    />

    <div class="flex flex-col items-start gap-3 sm:flex-row sm:items-center">
      <button
        [disabled]="sending() || forgotPasswordForm.invalid"
        (click)="sendCode()"
        matRipple
        class="bg-transparent border border-nav-btn-border text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text px-6 py-2 rounded-full disabled:opacity-50 disabled:cursor-not-allowed inter-500 text-[16px] transform transition duration-150 ease-out active:scale-[0.98] focus:outline-none flex items-center justify-center gap-2 min-w-[110px]"
      >
        @if (sending()) {
          <svg
            class="animate-spin"
            width="20"
            height="20"
            viewBox="0 0 25 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="COCO/Line/Rotate - Right">
              <path
                id="Vector"
                d="M21.5059 12.7058C21.5059 17.5921 17.4764 21.5532 12.5059 21.5532C7.5353 21.5532 3.50586 17.5921 3.50586 12.7058C3.50586 7.81945 7.50586 3.8583 12.5059 3.8583C18.5059 3.8583 21.5059 8.77356 21.5059 8.77356M21.5059 8.77356L21.5059 3.55322M21.5059 8.77356H16.8508"
                class="opacity-30 stroke-current"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
        }
        <span>{{ sending() ? 'Sending' : 'Send' }}</span>
      </button>
      <button
        type="button"
        (click)="backToLogin()"
        class="font-spaceGrotesk text-sm text-support-text transition-colors hover:text-kek-purple"
      >
        Return to login
      </button>
    </div>
  </div>
</app-auth-shell>
